module.exports = __webpack_public_path__ + "img/diamond.aed8db39.svg";